import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout della sezione Campagne: index (lista) e $planId (esecuzione) nidificati. */
export const Route = createFileRoute('/_app/test-plans')({ component: () => <Outlet /> });
